import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbCheckbox } from "abreact/input/AbCheckbox";
import { AbItemUtils } from "abreact/misc/AbItemUtils";
import { AbEnriched } from "abreact/utils/enrichment/AbEnriched";
import { AbKeySet } from "abweb/collection/AbKeySet";
import { TypeUtils } from "abweb/utils/TypeUtils";
import * as React from "react";

/**
 * The properties for an AbCheckboxGroup.
 */

export const AbCheckboxGroup = props => {
  const valueSet = AbKeySet.from(Array.from(props.value, AbEnriched.getItem), props.keyFunction); // Calculate on every render because value set contents may change without props.value changing.
  const renderItem = maybeEnrichedItem => {
    const {
      item,
      enrichment
    } = AbEnriched.extract(maybeEnrichedItem);
    return /*#__PURE__*/React.createElement(AbCheckbox, {
      key: TypeUtils.itemToKey(item, props.keyFunction),
      value: valueSet.has(item),
      onChange: checked => {
        const maybeEnrichedValueSet = AbKeySet.from(props.value, AbEnriched.createMaybeEnrichedKeyFunction(props.keyFunction));
        if (checked) {
          props.onChange(valueSet.add(item).toSet(), maybeEnrichedValueSet.add(maybeEnrichedItem).toSet());
        } else {
          props.onChange(valueSet.difference([item]).toSet(), maybeEnrichedValueSet.difference([maybeEnrichedItem]).toSet());
        }
      },
      disabled: props.disabled || enrichment?.disabled,
      className: enrichment?.className,
      tooltip: enrichment?.tooltip,
      tabIndex: props.tabIndex,
      label: (props.itemRenderer ?? AbItemUtils.defaultItemDisplayName)(item, enrichment)
    });
  };
  const checkboxGroupStyle = {
    ...props.style,
    "--ab-checkbox-group-columns-private": props.columns ?? 1
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps("ab-checkbox-group", props), {
    style: checkboxGroupStyle
  }), Array.from(props.items, renderItem));
};
//# sourceMappingURL=AbCheckboxGroup.js.map
